// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */

// https://product-fabric.atlassian.net/wiki/spaces/ADF/pages/881362244/ADF+Change+42+Uniform+Empty+ADF+Representation
export var getEmptyADF = function getEmptyADF() {
  return {
    type: 'doc',
    version: 1,
    content: []
  };
};
export { isEmpty } from './transforms/helpers';